import React, {useEffect, useState} from 'react';
import {Button, Modal, Select} from 'antd';
import {TaskModel} from "../../models/TaskModel";
import _ from "lodash";

type ModalProps = {
    visible: boolean;
    setVisible: Function;
    filterByFilial: string | null;
    filterByObject: string | null;
    setFilterByFilial: Function;
    setFilterByObject: Function;
    tasks: TaskModel[];
}
export const FilterModal = (props: ModalProps) => {
    const [objects, setObjects] = useState<{ value: string | undefined, label: string | undefined }[]>(() => _.uniq(props.tasks.map((task: TaskModel) => task.object)).map((object: string | undefined) => ({
        value: object,
        label: object
    })));
    const clearFiltersHandler = () => {
        props.setFilterByObject(null)
        props.setFilterByFilial(null)
        props.setVisible(false)
    }
    const handleChangeFilial = (value: string) => {
        props.setFilterByFilial(value);
    };
    const handleChangeObject = (value: string) => {
        props.setFilterByObject(value);
    };
    useEffect(() => {
        if (props.filterByFilial) {
            setObjects(_.uniq(props.tasks.filter((task: TaskModel) => task.filial === props.filterByFilial).map((task:TaskModel) => task.object)).map((object: string | undefined) => ({
                value: object,
                label: object
            })))
        }
    }, [props.filterByFilial])
    return (
        <Modal open={props.visible} onCancel={() => props.setVisible(false)} footer={[
            <Button key="submit" type="primary" onClick={clearFiltersHandler}>
                Очистить фильтры
            </Button>,
            <Button key="submit" type="primary" onClick={() => props.setVisible(false)}>
                Назад
            </Button>
        ]} title="Настройки фильтра">
            <Select
                value={props.filterByFilial}
                placeholder="Выберите филиал"
                style={{width: '100%', marginBottom: '15px'}}
                onChange={handleChangeFilial}
                options={_.uniq(props.tasks.map((task: TaskModel) => task.filial)).map((filial: string | undefined) => ({
                    value: filial,
                    label: filial
                }))}
            />
            <Select
                placeholder="Выберите объект"
                value={props.filterByObject}
                style={{width: '100%'}}
                onChange={handleChangeObject}
                options={objects}
            />
        </Modal>
    );
};